module.exports = __webpack_public_path__ + "static/img/partner-logo15.0223dc65.png";